module.exports = __webpack_public_path__ + "static/media/Great_Shoals.2fe8d6bf.png";